/* tslint:disable */
/* eslint-disable */
/**
 * openapi
 * bales cloud
 *
 * The version of the OpenAPI document: 1.0
 * Contact: test@example.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { GetPlaceholders200Response } from '../models';
/**
 * PlaceholderApi - axios parameter creator
 * @export
 */
export const PlaceholderApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * プレースホルダー一覧取得API
         * @summary プレースホルダー一覧取得API
         * @param {boolean} [isMail] メールかどうか
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPlaceholders: async (isMail?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/user/placeholders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (isMail !== undefined) {
                localVarQueryParameter['isMail'] = isMail;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PlaceholderApi - functional programming interface
 * @export
 */
export const PlaceholderApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PlaceholderApiAxiosParamCreator(configuration)
    return {
        /**
         * プレースホルダー一覧取得API
         * @summary プレースホルダー一覧取得API
         * @param {boolean} [isMail] メールかどうか
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPlaceholders(isMail?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetPlaceholders200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPlaceholders(isMail, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * PlaceholderApi - factory interface
 * @export
 */
export const PlaceholderApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PlaceholderApiFp(configuration)
    return {
        /**
         * プレースホルダー一覧取得API
         * @summary プレースホルダー一覧取得API
         * @param {boolean} [isMail] メールかどうか
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPlaceholders(isMail?: boolean, options?: any): AxiosPromise<GetPlaceholders200Response> {
            return localVarFp.getPlaceholders(isMail, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PlaceholderApi - interface
 * @export
 * @interface PlaceholderApi
 */
export interface PlaceholderApiInterface {
    /**
     * プレースホルダー一覧取得API
     * @summary プレースホルダー一覧取得API
     * @param {boolean} [isMail] メールかどうか
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlaceholderApiInterface
     */
    getPlaceholders(isMail?: boolean, options?: AxiosRequestConfig): AxiosPromise<GetPlaceholders200Response>;

}

/**
 * Request parameters for getPlaceholders operation in PlaceholderApi.
 * @export
 * @interface PlaceholderApiGetPlaceholdersRequest
 */
export interface PlaceholderApiGetPlaceholdersRequest {
    /**
     * メールかどうか
     * @type {boolean}
     * @memberof PlaceholderApiGetPlaceholders
     */
    readonly isMail?: boolean
}

/**
 * PlaceholderApi - object-oriented interface
 * @export
 * @class PlaceholderApi
 * @extends {BaseAPI}
 */
export class PlaceholderApi extends BaseAPI implements PlaceholderApiInterface {
    /**
     * プレースホルダー一覧取得API
     * @summary プレースホルダー一覧取得API
     * @param {PlaceholderApiGetPlaceholdersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlaceholderApi
     */
    public getPlaceholders(requestParameters: PlaceholderApiGetPlaceholdersRequest = {}, options?: AxiosRequestConfig) {
        return PlaceholderApiFp(this.configuration).getPlaceholders(requestParameters.isMail, options).then((request) => request(this.axios, this.basePath));
    }
}
